import initCardsBenefitsSlider from '../../scripts/initCardsBenefitsSlider';

export default {
	data() {
		return {
			cardType: '',
			creditCardType: 'classic',
			isClient: 'steps',
            hasCard: 'true'
		}
	},
	methods: {
		selectCardType(type) {
			this.cardType = type;
		}
	},
	mounted() {
		if (location.hash) {
			this.selectCardType(location.hash.slice(1));
		}

		window.initCardsBenefitsSlider = initCardsBenefitsSlider;
	}
}
